/**
 * 视图注册 - 在这里注册所有的权益卡片视图
 */
import { viewRegistry, ViewConfig } from '../ViewRegistry';
import JiGouCard from './components/jigou-card/index.vue';
import ZhenXiangCard from './components/zhenxiang-card/index.vue';
import YouSuCard from './components/yousu-card/index.vue';
import { jiGouCardConfig } from './components/jigou-card/config';
import { zhenXiangCardConfig } from './components/zhenxiang-card/config';
import { youSuCardConfig } from './components/yousu-card/config';

/**
 * 注册所有视图
 * 在应用启动时调用一次即可
 */
export function registerAllViews(): void {
  const configs: ViewConfig[] = [
    jiGouCardConfig,
    zhenXiangCardConfig,
    youSuCardConfig,
  ];

  // 批量注册视图
  viewRegistry.registerBatch(configs);
}

export function registerCustomView(config: ViewConfig): void {
  viewRegistry.register(config);
}

/**
 * 导出视图组件，供外部直接使用
 */
export { JiGouCard, YouSuCard, ZhenXiangCard };
